import React from 'react';
import { rem } from '@heathmont/moon-utils';
import styled, { css } from 'styled-components';
import type ArticleType from '~/client/components/Blog/shared/articles/BlogArticle/ArticleType';
import media from '~/client/shared/media';

const baseContainerStyle = ({ theme }: { theme: Theme }) => css`
  position: relative;
  z-index: 1;
  margin: -${rem(48)} ${rem(48)} 0 0;
  padding: ${rem(14)} ${rem(36)} 0 0;
  letter-spacing: ${rem(1)};
  border-radius: 0 ${rem(4)};
  background: ${theme.color.goku[100]};
  ${media.desktopSmall} {
    border-radius: ${rem(4)} 0 0;
  }
`;

const bigStyle = css`
  padding: ${rem(14)} ${rem(36)} 0 0;
  ${media.phoneMedium} {
    padding: ${rem(24)} ${rem(36)} 0 0;
  }
  ${media.desktopSmall} {
    margin: -${rem(48)} 0 0 17%;
    padding: ${rem(16)} ${rem(36)} 0 ${rem(40)};
  }
`;

const smallStyle = css`
  border-radius: 0;
  background: none;
  margin: ${rem(12)} ${rem(48)} 0 0;
  padding: 0 ${rem(32)} 0 0;
`;

const landscapeStyle = css`
  border-radius: 0;
  background: none;
  float: left;
  width: calc(100% - 1 ${rem(36)});
  margin: ${rem(1)} 0 0;
  padding: 0 0 0 ${rem(16)};
  ${media.desktopSmall} {
    width: calc(50% + ${rem(10)});
  }
`;

const SIZE_STYLES = {
  big: bigStyle,
  small: smallStyle,
};

type LayoutProps = {
  size: 'big' | 'small';
  type: ArticleType;
  children: React.ReactNode;
};

const Container = styled.div((props: LayoutProps) => [
  baseContainerStyle,
  SIZE_STYLES[props.size],
  props.type === 'landscape' && landscapeStyle,
]);

export default Container;
